var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import ImportWizardNavigation from "./importWizardNavigation";
import { ImportContext } from "./importWizard";
import { DragDropContext, Draggable, Droppable, } from "react-beautiful-dnd";
import Input from "@mui/joy/Input";
import { useGetDuplicateCheckImportQuery, useGetExecuteImportQuery, } from "@/store/api";
import copy from "fast-copy";
import { LoaderImage } from "@/utils/loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faCircleXmark, } from "@fortawesome/pro-regular-svg-icons";
import { Tooltip } from "react-tooltip";
import { useTranslation } from "react-i18next";
import logger from "js-logger";
/**
 * Composant pour l'import des enregistrements
 * @param param0
 * @returns
 */
export default function Step5(_a) {
    var settings = _a.settings, goto = _a.goto;
    var importSettings = useContext(ImportContext);
    var t = useTranslation(["Import"]).t;
    var mappedData = copy(settings === null || settings === void 0 ? void 0 : settings.mapping);
    delete mappedData.labels;
    delete mappedData.rows;
    // Check duplicate
    var _b = useGetDuplicateCheckImportQuery({
        params: {
            name: (settings === null || settings === void 0 ? void 0 : settings.file) != null && (settings === null || settings === void 0 ? void 0 : settings.file.name),
            content: settings === null || settings === void 0 ? void 0 : settings.uploadFileName,
            delimiter: settings.delimiter,
            enclosure: settings.enclosure,
            importSource: settings.source,
            hasHeader: settings.hasHeader,
            mapping: JSON.stringify(Object.entries(mappedData)),
            lang: "en_us",
        },
        moduleName: settings.selectedModule,
    }), dupCheck = _b.data, isLoading = _b.isLoading;
    var _c = useState(false), canImport = _c[0], setCanImport = _c[1];
    var _d = useState(dupCheck === null || dupCheck === void 0 ? void 0 : dupCheck.data.fileTotal), filesToImport = _d[0], setFilesToImport = _d[1];
    //const [totalRecords, setTotalRecords] = useState(dupCheck?.data.recordCount);
    var _e = useState(0), currentFileId = _e[0], setCurrentFileId = _e[1];
    var _f = useState({
        items: dupCheck === null || dupCheck === void 0 ? void 0 : dupCheck.data.dupeEnabled,
        selected: dupCheck === null || dupCheck === void 0 ? void 0 : dupCheck.data.dupeDisabled,
    }), state = _f[0], setState = _f[1];
    useEffect(function () {
        if (dupCheck && dupCheck.data) {
            setCanImport(true);
            setState({
                items: dupCheck === null || dupCheck === void 0 ? void 0 : dupCheck.data.dupeEnabled,
                selected: dupCheck === null || dupCheck === void 0 ? void 0 : dupCheck.data.dupeDisabled,
            });
            setFilesToImport(dupCheck === null || dupCheck === void 0 ? void 0 : dupCheck.data.fileTotal);
        }
        // Utiliser le nouveau fichier
        settings.newUploadFileName = dupCheck === null || dupCheck === void 0 ? void 0 : dupCheck.data.source;
    }, [dupCheck]);
    // Import now
    var _g = useState(true), isImport = _g[0], setIsImport = _g[1];
    var _h = useState(30), progression = _h[0], setProgression = _h[1];
    var _j = useGetExecuteImportQuery({
        params: {
            filename: (settings === null || settings === void 0 ? void 0 : settings.file) != null && (settings === null || settings === void 0 ? void 0 : settings.file.name),
            content: settings === null || settings === void 0 ? void 0 : settings.newUploadFileName,
            delimiter: settings.delimiter,
            enclosure: settings.enclosure,
            nbColumns: settings.nbColumns,
            dateformat: settings.dateFormat,
            timeformat: settings.timeFormat,
            timezone: settings.timeZone,
            importType: settings.importType,
            saveMapAs: settings.saveMapAs,
            hasHeader: settings.hasHeader,
            source: settings.source,
            defaultLocaleNameFormat: settings.defaultLocaleNameFormat,
            decSep: settings.decSep,
            numGroupSep: settings.numGroupSep,
            currencySignificantDigits: settings.currencySignificantDigits,
            mapping: JSON.stringify(Object.entries(mappedData)),
            lang: "en_us",
        },
        moduleName: settings.selectedModule,
    }, { skip: isImport }), importData = _j.data, isFetching = _j.isFetching;
    useEffect(function () {
        var fileId = 0;
        setProgression(((fileId + 1) * 100) / filesToImport);
        logger.debug("PROCESSING FILE", fileId, progression);
        setCurrentFileId(currentFileId);
    }, [isFetching]);
    function getLevel(step) {
        settings.step = step;
        if (step === 6) {
            step === 6 && setIsImport(function (prev) { return !prev; });
        }
        else {
            goto("Step".concat(step));
        }
    }
    useEffect(function () {
        var _a, _b;
        ((_a = importData === null || importData === void 0 ? void 0 : importData.data) === null || _a === void 0 ? void 0 : _a.message) &&
            ((_b = importData === null || importData === void 0 ? void 0 : importData.data) === null || _b === void 0 ? void 0 : _b.message) === "success" &&
            goto("Step".concat(settings.step));
    }, [importData]);
    var grid = 2;
    var getItemStyle = function (isDragging, draggableStyle) { return (__assign({ 
        // some basic styles to make the items look a bit nicer
        userSelect: "none", padding: grid * 2, margin: "0 0 ".concat(grid, "px 0"), 
        // change background colour if dragging
        background: isDragging ? "white" : "white" }, draggableStyle)); };
    var getListStyle = function (isDraggingOver) { return ({
        /*background: isDraggingOver ? "lightgrey" : "white",
        padding: grid,*/
        width: 400,
    }); };
    var reorder = function (list, startIndex, endIndex) {
        var result = Array.from(list);
        var removed = result.splice(startIndex, 1)[0];
        result.splice(endIndex, 0, removed);
        return result;
    };
    var id2List = {
        droppable: "items",
        droppable2: "selected",
    };
    // Drag to other list function
    var move = function (source, destination, droppableSource, droppableDestination) {
        var sourceClone = Array.from(source);
        var destClone = Array.from(destination);
        var removed = sourceClone.splice(droppableSource.index, 1)[0];
        destClone.splice(droppableDestination.index, 0, removed);
        var result = {};
        result[droppableSource.droppableId] = sourceClone;
        result[droppableDestination.droppableId] = destClone;
        return result;
    };
    var getList = function (id) { return state[id2List[id]]; };
    // Drag end function
    var onDragEnd = function (result) {
        var source = result.source, destination = result.destination;
        // dropped outside the list
        if (!destination) {
            return;
        }
        if (source.droppableId === destination.droppableId) {
            var items = reorder(getList(source.droppableId), source.index, destination.index);
            var s = { items: items, selected: state.selected };
            if (source.droppableId === "droppable2") {
                s = { items: state === null || state === void 0 ? void 0 : state.items, selected: items };
            }
            setState(s);
        }
        else {
            var result_1 = move(getList(source.droppableId), getList(destination.droppableId), source, destination);
            setState({
                items: result_1.droppable,
                selected: result_1.droppable2,
            });
        }
    };
    // Fix error : Unable to find draggable with id: item-id
    var StrictModeDroppable = function (_a) {
        var children = _a.children, props = __rest(_a, ["children"]);
        var _b = useState(false), enabled = _b[0], setEnabled = _b[1];
        useEffect(function () {
            var animation = requestAnimationFrame(function () { return setEnabled(true); });
            return function () {
                cancelAnimationFrame(animation);
                setEnabled(false);
            };
        }, []);
        if (!enabled) {
            return null;
        }
        return _jsx(Droppable, __assign({}, props, { children: children }));
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "content" }, { children: [isLoading && _jsx(LoaderImage, {}), _jsx("div", __assign({ className: "flex flex-row justify-center mb-8" }, { children: _jsxs(DragDropContext, __assign({ onDragEnd: onDragEnd }, { children: [_jsx(StrictModeDroppable, __assign({ droppableId: "droppable" }, { children: function (provided, snapshot) { return (_jsxs("div", __assign({}, provided.droppableProps, { ref: provided.innerRef, style: getListStyle(snapshot.isDraggingOver), className: "bg-white shadow-md rounded-sm p-4 m-4 " }, { children: [_jsx("header", __assign({ className: "text-lg font-bold" }, { children: "Fields to check" })), _jsx("hr", { className: "my-2 border-t " }), state.items &&
                                            state.items.map(function (item, index) { return (_jsx(Draggable, __assign({ draggableId: item.id, index: index }, { children: function (provided, snapshot) { return (_jsx("div", __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { style: getItemStyle(snapshot.isDragging, provided.draggableProps.style) }, { children: item.label }))); } }), item.id)); }), provided.placeholder] }))); } })), _jsx(StrictModeDroppable, __assign({ droppableId: "droppable2" }, { children: function (provided, snapshot) { return (_jsxs("div", __assign({}, provided.droppableProps, { ref: provided.innerRef, style: getListStyle(snapshot.isDraggingOver), className: "bg-white shadow-md rounded-sm p-4 m-4 " }, { children: [_jsx("header", __assign({ className: "text-lg font-bold" }, { children: "Available fields" })), _jsx("hr", { className: "my-2 border-t " }), state.selected &&
                                            state.selected.map(function (item, index) { return (_jsx(Draggable, __assign({ draggableId: item.id, index: index }, { children: function (provided, snapshot) { return (_jsx("div", __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { style: getItemStyle(snapshot.isDragging, provided.draggableProps.style) }, { children: item.label }))); } }), item.id)); }), provided.placeholder] }))); } }))] })) })), _jsxs("div", __assign({ className: "flex" }, { children: [_jsx("label", { children: "To save the import settings, provide a name for the saved settings :" }), _jsx(FontAwesomeIcon, { className: "dupchek text-gray-500 ml-2 mt-2", icon: faCircleInfo }), _jsx(Tooltip, __assign({ className: "z-[1000]", anchorSelect: ".dupchek", place: "top", variant: "info", style: { width: "250px" } }, { children: t("LBL_SAVE_MAPPING_HELP") })), _jsx(Input, { type: "text", size: "sm", className: "w-[50%] ml-2", defaultValue: settings.saveMapAs && settings.saveMapAs, onChange: function (event) {
                                settings.saveMapAs = event.target.value;
                            } })] })), _jsx(ImportWizardNavigation, { hasPrevious: true, hasNext: false, hasImport: canImport, previousEnabled: false, nextEnabled: false, importEnabled: false, level: getLevel }), isFetching && (_jsx("div", __assign({ className: "absolute left-0 flex top-0 w-full h-full after:content-[''] after:bg-gray-200 after:z-[100] after:w-full after:h-full after:left-0 after:right-0 after:absolute after:opacity-70" }, { children: _jsx("div", __assign({ className: "flex flex-row items-center justify-center w-full h-full backdrop-blur-sm z-[101]" }, { children: _jsx("div", __assign({ className: "flex justify-center " }, { children: _jsxs("div", __assign({ className: "shadow-md p-8 justify-center m-4 relative" }, { children: [_jsxs("header", { children: [_jsx("p", { children: "Processing import" }), _jsx("span", __assign({ className: "absolute top-0 right-0 ", onClick: function () {
                                                    setCurrentFileId(0);
                                                    //importData?.abort();
                                                    //setIsImport(true);
                                                } }, { children: _jsx(FontAwesomeIcon, { icon: faCircleXmark, className: "cursor-pointer text-gray-400" }) }))] }), _jsxs("section", { children: [currentFileId, "/", filesToImport, " file(s) imported", _jsx("progress", { value: progression, className: "ml-2", max: 100 })] }), _jsx("footer", {})] })) })) })) })))] })) }));
}
